export const COLOR_CONST = {
  bgColor1: '#316A58',
  titleColor: '#F1BE3E',
  descriptionColor: '#fff',
  cardTitleColor: '#FE93A1',
  cardFeatureBgColor: '#F2F4F7',
  cardFontColor: '#344054',
  bgColor2: '#F2F4F7'
};
